export default "__VITE_ASSET__DsAB4igA__"